var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu spaceCenter" }, [
    _c(
      "div",
      { staticClass: "page-menu-main" },
      [
        _c(
          "el-radio-group",
          {
            on: { change: _vm.menuChange },
            model: {
              value: _vm.activeKey,
              callback: function ($$v) {
                _vm.activeKey = $$v
              },
              expression: "activeKey",
            },
          },
          [
            _c("el-radio-button", { attrs: { label: "lending" } }, [
              _vm._v("Borrow"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "auction" } }, [
              _vm._v("Auction"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "profile" } }, [
              _vm._v("Profile"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }